<template>
  <div class="app">
    
    <HeaderSearch/>
    <IndustryList/>
    <SelectedList/>
  </div>
</template>

<script>
import HeaderSearch from "@/components/Home/HeaderSearch";
import IndustryList from "@/components/Home/IndustryList";
import SelectedList from "@/components/Home/SelectedList";
export default {
  name: "home",
  components:{IndustryList,SelectedList,HeaderSearch},

  data() {
    return {
      isEjected: "",
    };
  },
  computed: {
   
  },
  watch: {
   
  },
  created() {
   
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/config";

.app {
  min-width: $layout-body-width;

  .bottom-banner-container {
    position: relative;
    z-index: 100;
    ::v-deep .RegisterBottomBanner-box {
      height: 0 !important;
    }
  }
}
</style>
